/* ============ TOVU THEME JS ============ */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- TOAST ---------- */
  window.toast = function (msg, type) {
    type = type || 'success';
    var wrap = $('#toastWrap');
    if (!wrap) return;
    var icons = { success: 'fa-check', info: 'fa-info', error: 'fa-xmark' };
    var t = document.createElement('div');
    t.className = 'toast ' + type;
    t.innerHTML = '<div class="ic"><i class="fa-solid ' + (icons[type] || 'fa-check') + '"></i></div><span>' + msg + '</span>';
    wrap.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('show'); });
    setTimeout(function () { t.classList.remove('show'); setTimeout(function () { t.remove(); }, 400); }, 3200);
  };

  /* ---------- THEME TOGGLE ---------- */
  window.toggleTheme = function () {
    var cur = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', cur);
    localStorage.setItem('tovu_theme', cur);
    var icon = $('#themeBtn i');
    if (icon) icon.className = cur === 'dark' ? 'fa-solid fa-sun' : 'fa-solid fa-moon';
    var ml = $('#mmThemeLabel');
    if (ml) ml.textContent = cur === 'dark' ? 'Light mode' : 'Dark mode';
  };
  (function () {
    var dark = document.documentElement.getAttribute('data-theme') === 'dark';
    var icon = $('#themeBtn i');
    if (icon && dark) icon.className = 'fa-solid fa-sun';
    var ml = $('#mmThemeLabel');
    if (ml) ml.textContent = dark ? 'Light mode' : 'Dark mode';
  })();

  /* ---------- MOBILE MENU ---------- */
  window.openMobileMenu = function () { $('#mobileMenu') && $('#mobileMenu').classList.add('open'); $('#menuOverlay') && $('#menuOverlay').classList.add('open'); document.body.classList.add('no-scroll'); };
  window.closeMobileMenu = function () { $('#mobileMenu') && $('#mobileMenu').classList.remove('open'); $('#menuOverlay') && $('#menuOverlay').classList.remove('open'); document.body.classList.remove('no-scroll'); };
  // Mobile menu accordion: expand/collapse a parent's sub-menu
  window.toggleMmAcc = function (btn) {
    var acc = btn.closest('.mm-acc');
    if (!acc) return;
    var isOpen = acc.classList.toggle('open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    var icon = btn.querySelector('i');
    if (icon) { icon.classList.toggle('fa-plus', !isOpen); icon.classList.toggle('fa-minus', isOpen); }
  };

  /* ---------- SEARCH ---------- */
  window.openSearch = function () { var o = $('#searchOverlay'); if (o) { o.classList.add('open'); var i = $('#searchInput'); if (i) setTimeout(function () { i.focus(); }, 100); } };
  window.closeSearch = function () { $('#searchOverlay') && $('#searchOverlay').classList.remove('open'); };
  window.quickSearch = function (term) { window.location.href = '/search?q=' + encodeURIComponent(term); };

  /* ---------- CART DRAWER ---------- */
  window.openCart = function () { $('#cartDrawer') && $('#cartDrawer').classList.add('open'); $('#cartOverlay') && $('#cartOverlay').classList.add('open'); document.body.classList.add('no-scroll'); };
  window.closeCart = function () { $('#cartDrawer') && $('#cartDrawer').classList.remove('open'); $('#cartOverlay') && $('#cartOverlay').classList.remove('open'); document.body.classList.remove('no-scroll'); };

  function refreshCartUI() {
    return fetch('/?section_id=header').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newDrawer = doc.querySelector('#cartDrawer');
      var newBadge = doc.querySelector('#cartBadge');
      if (newDrawer && $('#cartDrawer')) $('#cartDrawer').innerHTML = newDrawer.innerHTML;
      if (newBadge && $('#cartBadge')) {
        $('#cartBadge').textContent = newBadge.textContent;
        $('#cartBadge').style.display = newBadge.textContent.trim() === '0' ? 'none' : '';
      }
    });
  }

  // Add to cart by variant id (used by product cards)
  window.addToCartId = function (variantId) {
    if (!variantId) { window.toast('This product is unavailable', 'error'); return; }
    var vid = parseInt(variantId, 10);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    }).then(function (res) {
      if (!res.ok) {
        window.toast((res.data && res.data.description) || 'Could not add to cart', 'error');
        return;
      }
      return refreshCartUI().then(function () { window.toast('Added to cart!'); });
    }).catch(function () {
      window.toast('Could not add to cart', 'error');
    });
  };

  // Change line quantity in drawer / cart page
  window.changeQty = function (key, qty) {
    qty = parseInt(qty, 10); if (isNaN(qty) || qty < 0) qty = 0;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () {
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      return refreshCartUI();
    });
  };

  // Intercept ANY add-to-cart form submit -> background AJAX add (no redirect)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;

    // Does this form post to Shopify's cart? (product forms, quick-add forms, etc.)
    var action = (form.getAttribute('action') || '').toLowerCase();
    var isCartForm = form.id === 'product-form'
      || action.indexOf('/cart/add') !== -1
      || (action.indexOf('/cart') !== -1 && form.querySelector('[name="id"]'))
      || form.querySelector('button[name="add"], input[name="add"]');

    if (!isCartForm) return;

    e.preventDefault();
    var fd = new FormData(form);
    var isBuyNow = (document.activeElement && document.activeElement.name === 'checkout');

    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          window.toast((res.data && res.data.description) || 'Could not add to cart', 'error');
          return;
        }
        if (isBuyNow) { window.location.href = '/checkout'; return; }
        return refreshCartUI().then(function () { window.toast('Added to cart!'); });
      })
      .catch(function () {
        window.toast('Could not add to cart', 'error');
      });
  });

  // Catch-all: intercept clicks on cart-permalink "add" links (e.g. /cart/123:1)
  // so collection/quick-add links add in the background instead of navigating.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/cart/"]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    // match /cart/{variantId}:{qty}  (the permalink add format)
    var m = href.match(/\/cart\/(\d+):(\d+)/);
    if (!m) return;
    e.preventDefault();
    e.stopPropagation();
    var vid = parseInt(m[1], 10);
    var qty = parseInt(m[2], 10) || 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: qty })
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) { window.toast((res.data && res.data.description) || 'Could not add to cart', 'error'); return; }
        return refreshCartUI().then(function () { window.toast('Added to cart!'); });
      })
      .catch(function () { window.toast('Could not add to cart', 'error'); });
  }, true);

  /* ---------- PRODUCT PAGE: variant + qty + gallery ---------- */
  window.pdpSwap = function (el, src) {
    $$('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
    el.classList.add('active');
    var main = $('#pdpMainImg'); if (main) main.src = src;
  };
  window.pdpQty = function (delta) {
    var span = $('#pdpQtyVal'); var input = $('#pdpQtyInput'); if (!span) return;
    var v = parseInt(span.textContent, 10) + delta; if (v < 1) v = 1;
    span.textContent = v; if (input) input.value = v;
  };
  /* NOTE: onVariantChange is defined inside the product section (main-product.liquid),
     which has the correct option-value matching. A duplicate used to live here and
     shadowed it via window.*, breaking variant selection — removed intentionally. */

  /* ---------- PRODUCT TABS ---------- */
  window.pdpTab = function (btn, idx) {
    $$('.pdp-tab').forEach(function (t) { t.classList.remove('active'); });
    btn.classList.add('active');
    $$('.pdp-pane').forEach(function (p, i) { p.classList.toggle('active', i === idx); });
  };

  /* ---------- FOOTER ACCORDION (mobile) ---------- */
  window.toggleFooterCol = function (el) {
    if (window.innerWidth <= 768) el.parentElement.classList.toggle('open');
  };

  /* ---------- REVIEW CAROUSEL ---------- */
  var rcIndex = 0;
  function rcPerView() { return window.innerWidth <= 768 ? 1 : (window.innerWidth <= 1024 ? 2 : 3); }
  window.reviewGo = function (dir) {
    var track = $('#rcTrack'); if (!track) return;
    var slides = $$('.rc-slide', track); var per = rcPerView();
    var max = Math.max(0, slides.length - per);
    rcIndex += dir; if (rcIndex < 0) rcIndex = max; if (rcIndex > max) rcIndex = 0;
    track.style.transform = 'translateX(-' + (rcIndex * (100 / per)) + '%)';
    track.style.transition = 'transform .5s cubic-bezier(.2,.7,.3,1)';
    updateDots();
  };
  function updateDots() {
    var dots = $('#rcDots'); var track = $('#rcTrack'); if (!dots || !track) return;
    var slides = $$('.rc-slide', track); var per = rcPerView();
    var count = Math.max(1, slides.length - per + 1);
    dots.innerHTML = '';
    for (var i = 0; i < count; i++) {
      var d = document.createElement('span');
      d.className = 'rc-dot' + (i === rcIndex ? ' active' : '');
      (function (idx) { d.onclick = function () { rcIndex = idx; reviewGo(0); }; })(i);
      dots.appendChild(d);
    }
  }
  if ($('#rcTrack')) { updateDots(); window.addEventListener('resize', function () { rcIndex = 0; reviewGo(0); }); }

  /* ---------- SCROLL: header shadow + back to top ---------- */
  window.addEventListener('scroll', function () {
    var h = $('#header'), bt = $('#backTop');
    if (h) h.classList.toggle('scrolled', window.scrollY > 20);
    if (bt) bt.classList.toggle('show', window.scrollY > 500);
  });
  var backTop = $('#backTop');
  if (backTop) backTop.onclick = function () { window.scrollTo({ top: 0, behavior: 'smooth' }); };

  /* ---------- REVEAL ON SCROLL ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  $$('.reveal').forEach(function (el) {
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight * 0.92) el.classList.add('in'); else io.observe(el);
  });

  /* ---------- ESC closes overlays ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeSearch(); closeMobileMenu(); }
  });

  /* ---------- RECENTLY VIEWED ---------- */
  var RV_KEY = 'tovu_recent';
  function getRecent() { try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; } }
  function setRecent(arr) { localStorage.setItem(RV_KEY, JSON.stringify(arr.slice(0, 12))); }

  // Record current product (the product page sets window.TOVU_PRODUCT_HANDLE)
  if (window.TOVU_PRODUCT_HANDLE) {
    var list = getRecent().filter(function (h) { return h !== window.TOVU_PRODUCT_HANDLE; });
    list.unshift(window.TOVU_PRODUCT_HANDLE);
    setRecent(list);
  }

  // Render the recently-viewed strip on any page that has #rvSection
  var rvSection = $('#rvSection');
  if (rvSection) {
    var handles = getRecent();
    // don't show the product currently being viewed
    if (window.TOVU_PRODUCT_HANDLE) {
      handles = handles.filter(function (h) { return h !== window.TOVU_PRODUCT_HANDLE; });
    }
    var max = parseInt(rvSection.getAttribute('data-max') || '6', 10);
    handles = handles.slice(0, max);

    if (handles.length >= 2) {
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var strip = $('#rvStrip');
        var html = products.filter(Boolean).map(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var price = '$' + (p.price / 100).toFixed(2);
          return '<a class="rv-card" href="/products/' + p.handle + '">' +
                 '<img loading="lazy" src="' + img + '" alt="' + p.title.replace(/"/g, '&quot;') + '">' +
                 '<div class="b"><div class="n">' + p.title + '</div><div class="p">' + price + '</div></div></a>';
        }).join('');
        if (html) { strip.innerHTML = html; rvSection.style.display = 'block'; }
      });
    }
  }
})();

/* ============ WISHLIST (localStorage) ============ */
(function(){
  var WISH_KEY = 'tovu_wish';
  function getWish(){ try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch(e){ return []; } }
  function setWish(a){ localStorage.setItem(WISH_KEY, JSON.stringify(a)); }

  // Header badge reflects number of saved items
  window.updateWishBadge = function(){
    var badge = document.getElementById('wishBadge');
    if(!badge) return;
    var n = getWish().length;
    badge.textContent = n;
    badge.style.display = n > 0 ? 'flex' : 'none';
  };

  // Toggle a product handle in/out of the wishlist
  window.toggleWish = function(handle, btn){
    if(!handle) return;
    var list = getWish();
    var on;
    if(list.indexOf(handle) > -1){ list = list.filter(function(h){ return h !== handle; }); on = false; }
    else { list.push(handle); on = true; }
    setWish(list);
    if(btn){
      btn.classList.toggle('active', on);
      var i = btn.querySelector('i');
      if(i) i.className = (on ? 'fa-solid' : 'fa-regular') + ' fa-heart';
    }
    window.updateWishBadge();
  };

  // Wire up any heart with data-wish="{handle}", and set initial state
  function initHearts(root){
    (root || document).querySelectorAll('[data-wish]').forEach(function(btn){
      if(btn.dataset.wishBound) return;
      btn.dataset.wishBound = '1';
      var handle = btn.getAttribute('data-wish');
      var on = getWish().indexOf(handle) > -1;
      btn.classList.toggle('active', on);
      var i = btn.querySelector('i');
      if(i) i.className = (on ? 'fa-solid' : 'fa-regular') + ' fa-heart';
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        window.toggleWish(handle, btn);
      });
    });
  }
  window.initWishHearts = initHearts;

  document.addEventListener('DOMContentLoaded', function(){ initHearts(); window.updateWishBadge(); });
  // in case the script runs after DOMContentLoaded
  if(document.readyState !== 'loading'){ initHearts(); window.updateWishBadge(); }

  /* ---------- ROBUST MENU BINDING (delegated, works even if inline onclick fails) ---------- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('.hamburger, [data-open-menu]');
    if (openBtn) { e.preventDefault(); window.openMobileMenu(); return; }

    var closeBtn = e.target.closest('[data-close-menu], #menuOverlay');
    if (closeBtn) { e.preventDefault(); window.closeMobileMenu(); return; }

    var accBtn = e.target.closest('.mm-acc-toggle');
    if (accBtn) { e.preventDefault(); window.toggleMmAcc(accBtn); return; }
  });
})();